var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('invoice-view',{model:{value:(_vm.invoice),callback:function ($$v) {_vm.invoice=$$v},expression:"invoice"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }